import React from "react";
import { makeStyles } from "@material-ui/core";
import { popoverColor, textColor, tooltipTextSize, borderRadiusValue } from "../lib/constants";
import { Tooltip } from "@material-ui/core";
import { useSelector } from "react-redux";

const useStepperTooltipStyle = makeStyles(
  {
    tooltipStyling: {
      color: textColor,
      backgroundColor: `${popoverColor} !important`,
      padding: "8px",
      borderRadius: borderRadiusValue,
      fontSize: tooltipTextSize,
      boxShadow: "rgb(213, 213, 213) 6px 6px 12px, rgb(255, 255, 255) -6px -6px 12px",
      fontWeight: "normal",
      marginLeft: "-6%",
    },
  },
  { name: "StepperTooltipStyles" },
);

export function StepperTooltip(props) {
  const { hoverTarget, children } = props;
  const classes = useStepperTooltipStyle();

  const pageNumber = useSelector((state) => state.pageNumber);

  const checkedText = useSelector((state) => state.checkedCardStepOne);
  const checkedCardPageTwo = useSelector((state) => state.checkedCardStepTwo);
  const checkedTagsPageThree = useSelector((state) => state.checkedTags);

  let tooltipMessage;

  // determine the tooltip text based on active page, hover target and user actions
  switch (pageNumber) {
    case 1:
      if (hoverTarget === 0) return children;
      else if (hoverTarget === 1)
        checkedText
          ? (tooltipMessage = "Zur Vergleichstextwahl")
          : (tooltipMessage = "Noch keinen Ausgangstext gewählt");
      else tooltipMessage = "Schritt noch nicht verfügbar";
      break;
    case 2:
      if (hoverTarget === 1) return children;
      else if (hoverTarget === 2)
        checkedCardPageTwo
          ? (tooltipMessage = "Zur Schlüsselwörterauswahl")
          : (tooltipMessage = "Noch keinen Vergleichstext gewählt");
      else if (hoverTarget > 2) tooltipMessage = "Schritt noch nicht verfügbar";
      else tooltipMessage = "Zurück zur Ausgangstextwahl";
      break;
    case 3:
      if (hoverTarget === 2) return children;
      else if (hoverTarget === 3)
        checkedTagsPageThree.length === 0
          ? (tooltipMessage = "Vernetzte Taxa in 3D darstellen")
          : (tooltipMessage = "Auswahl in 3D darstellen");
      else
        hoverTarget === 0
          ? (tooltipMessage = "Zurück zur Ausgangstextwahl")
          : (tooltipMessage = "Zurück zur Vergleichstextwahl");
      break;
    case 4:
      if (hoverTarget === 3) return children;
      else if (hoverTarget === 0) tooltipMessage = "Zurück zur Ausgangstextwahl";
      else
        hoverTarget === 1
          ? (tooltipMessage = "Zurück zur Vergleichstextwahl")
          : (tooltipMessage = "Zurück zur Schlüsselwortauswahl");
      break;
    case 5:
      return children;
    default:
      return children;
  }

  return (
    <Tooltip title={tooltipMessage} placement="right-start" classes={{ tooltip: classes.tooltipStyling }}>
      {children}
    </Tooltip>
  );
}
